import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button, Input, Table } from "reactstrap";
import { getAdminCompanyDeviceRecord } from "../../slices/admin/thunk";
import { useDispatch, useSelector } from "react-redux";
import CompanyDropdown from "./CompanyDropdownMenu";
import AdminDeviceRecordRow from "./AdminDeviceRecordRow";
import DeviceDropdown from "./DeviceDropdownMenu";
import AdminDeviceRecordModal from "./AdminDeviceRecordModal";
import LimitDropdown from "./LimitDropdown";
import { SELECTION_ALL } from "../../common/constants";

function AdminDeviceRecord(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    document.title = t('PageMain.DocumentTitle');
    const updates = useSelector(state => state.Admin.update);
    const data = useSelector(state => state.Admin.data.updates);
    const [searchWord, setSearchWord] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [isShowModal, setShowModal] = useState(false);
    const [modalDevice, setModalDevice] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(props.selectedDevice === null ? SELECTION_ALL : props.selectedDevice.companyID);
    const [selectedDevice, setSelectedDevice] = useState(props.selectedDevice === null ? SELECTION_ALL : props.selectedDevice.deviceID);
    const [limit, setLimit] = useState(20);

    async function fetchData() {
        dispatch(getAdminCompanyDeviceRecord(selectedDevice, selectedCompany, debouncedSearch, limit));
    }

    useEffect(() => {
        fetchData();
    }, [limit, selectedDevice, selectedCompany, debouncedSearch])

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchWord);
        }, 400); // wait 400ms after last keystroke

        return () => clearTimeout(timer);
    }, [searchWord]);

    const handleSelectCompany = (companyID) => {
        fetchData(selectedDevice, companyID);
        setSelectedCompany(companyID);
        setSelectedDevice(""); // Reset device selection when company changes
    };

    const handleSelectDevice = (deviceID) => {
        fetchData(deviceID, selectedCompany);
        setSelectedDevice(deviceID);
    };

    return (
        <Fragment>
            <div className="d-flex flex-row align-items-start justify-content-between">
                <div className="d-flex flex-row align-items-start justify-content-start">
                    <Button size="sm" color="primary" className="mb-2 me-2" onClick={()=>fetchData(selectedDevice, selectedCompany)}>{t('Common.Btn.Refresh')}</Button>
                    <div className="mb-3">
                        <Input
                            name="searchWord"
                            className="form-control"
                            placeholder={t('Common.Btn.Search')}
                            type="text"
                            value={searchWord}
                            onChange={(event) => {
                                setSearchWord(event.target.value);
                            }}
                        />
                    </div>
                    <CompanyDropdown onChange={handleSelectCompany} companyID={selectedCompany} />
                    <DeviceDropdown onChange={handleSelectDevice} companyID={selectedCompany} deviceID={selectedDevice} />
                    <LimitDropdown
                        selectedCompany={selectedCompany}
                        selectedDevice={selectedDevice}
                        limit={limit}
                        setLimit={setLimit}
                    />

                </div>
                <Button size="sm" color="secondary" className="mb-2 me-2" onClick={() => { setModalDevice(null); setShowModal(true); }}>{t('PageAdmin.Btn.CreateDeviceUpdate')}</Button>
            </div>


            <div className="device-table" style={{ maxHeight: '100%', overflowY: 'auto' }}>
                <Table className="table-nowrap mb-3">
                    <thead className="table-light sticky-header">
                        <tr>
                            <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.DeviceID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.SystemDeviceID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.Name')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.LastUpdatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.IssueNo')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.Info')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.Photo')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {updates.map((id) => {
                            const d = data[id];
                            return (
                                <AdminDeviceRecordRow
                                    data={d}
                                    key={d.id}
                                />
                            );
                        })}
                    </tbody>
                </Table>
                <AdminDeviceRecordModal show={isShowModal} onCloseClick={()=>{setShowModal(false)}} data={modalDevice} selectedCompany={selectedCompany} fetchData={fetchData}/>
            </div>
        </Fragment>
    );
}

export default AdminDeviceRecord;